// GTM events - add_to_cart genérico (adaptável)
document.addEventListener('DOMContentLoaded', function () {
  const addSelectors = document.querySelectorAll('form[action*="/cart/add"], button[data-add-to-cart], [data-add-to-cart]');

  addSelectors.forEach(function(el) {
    if (el.tagName.toLowerCase() === 'form') {
      el.addEventListener('submit', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [{
              item_id: el.querySelector('[name="id"]') ? el.querySelector('[name="id"]').value : null,
              item_name: el.querySelector('[name="title"]') ? el.querySelector('[name="title"]').value : document.title,
              quantity: 1
            }]
          }
        });
      });
    } else {
      el.addEventListener('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [{
              item_id: null,
              item_name: document.title,
              quantity: 1
            }]
          }
        });
      });
    }
  });
});